<template>
  <v-row dense justify="center">
    <v-col cols="12" class="content">
      <v-card>
        <v-container>
          <v-form ref="form">
            <v-col cols="12">
              <v-row align="center" justify="center" dense>
                <v-col :cols="12"
                       v-if="reportType==='outreach'"
                       sm="3">
                  <v-select ref="project"
                            v-model="project"
                            :items="projects"
                            :rules="[() => !!project || 'Поле обязательно']"
                            @input="setProject"
                            item-value="id"
                            item-text="name"
                            outlined
                            label="Проект" />
                </v-col>
                <v-col :cols="12" sm="2">
                  <BaseDatePicker ref="date"
                                  :rules="[() => !!date || 'Поле обязательно']"
                                  :value="date"
                                  :picker-type="reportType==='casemanagement' ? 'month' : 'date'"
                                  :label="reportType==='casemanagement' ? 'Месяц' : 'Дата'"
                                  @dateUpdated="setDate" />
                </v-col>
                
                <v-col :cols="12" sm="6">
                  <v-select ref="users"
                            :multiple="true"
                            :items="usersListFiltered"
                            :value="employees"
                            :rules="[() => !!employees.length > 0 || 'Поле обязательно']"
                            :max-elements="4"
                            :menu-props="{maxHeight:204, offsetY:true}"
                            @input="setEmlpoyees"
                            label="Сотрудники"
                            item-value="id"
                            item-text="name" />
                </v-col>

                <v-col v-if="reportType==='casemanagement'" :cols="12" sm="3">
                  <v-text-field ref="hours"
                                v-model="hours"
                                :rules="[() => !!hours || 'Поле обязательно']"
                                label="Количество часов" />
                </v-col>
              </v-row>
              <v-row align="center" justify="center" dense>
                <template v-if="reportType==='outreach'">
                  <v-col :cols="12" sm="3">
                    <v-select ref="hours"
                              v-model="hours"
                              :items="lengthHours"
                              :rules="[() => !!hours || 'Поле обязательно']"
                              label="Длительность выхода (часов)" />
                  </v-col>
                </template>
                <template v-if="reportType==='outreach'">
                  <v-col :cols="12" sm="4">
                    <v-select ref="place"
                              v-model="place"
                              :items="places"
                              :rules="[() => !!place || 'Поле обязательно']"
                              :max-elements="4"
                              :menu-props="{maxHeight:204, offsetY:true}"
                              @input="setLocation"
                              label="Место выхода"
                              item-value="id"
                              item-text="name" />
                  </v-col>
                </template>
                <v-col :cols="12" sm="4">
                  <v-text-field
                    ref="volunteer"
                    v-if="reportType==='outreach'"
                    v-model="volunteers"
                    label="Волонтеры" />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row align="center" justify="center">
                <v-btn
                  @click="submitReport"
                  color="primary"
                  class="mb-2">
                  Начать
                </v-btn>
              </v-row>
            </v-col>
          </v-form>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

import {mapState} from 'vuex'
import BaseDatePicker from '../../base/BaseDatePicker'
// import BaseMonthPicker from '../../base/BaseMonthPicker'

export default {
  name: "ReportOutreachNew",
  components: {BaseDatePicker
    // ,BaseMonthPicker
  },
  props: {
    reportId: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {
      tooltipShow: false,
      lengthHours: [2, 3, 4, 5],
      loading: false
    }
  },
  computed: {
    reportType () {
      return this.$route.meta.reportType
    },
    ...mapState({
      places: state => state.tableData.places,
      users: state => state.tableData.users,
      date: state => state.newOutreachReports.date,
      // place: state => state.newOutreachReports.place,
      employees: state => state.newOutreachReports.users,
      projects: state => state.tableData.projects
    }),
    hours: {
      get () {
        return this.$store.state.newOutreachReports.hours
      },
      set (hours) {
        this.$store.commit("newOutreachReports/setHours", hours)
      }
    },
    volunteers: {
      get () {
        return this.$store.state.newOutreachReports.volunteers
      },
      set (volunteers) {
        this.$store.commit("newOutreachReports/setVolunteers", volunteers)
      }
    },
    place: {
      get () {
        return this.$store.state.newOutreachReports.place
      },
      set (location) {
        this.$store.commit("newOutreachReports/setLocation", location)
      }
    },
    project: {
      get () {
        return this.$store.state.newOutreachReports.project
      },
      set (project) {
        this.$store.commit("newOutreachReports/setProject", project)
      }
    },
    usersListFiltered () {
      const newList = this.users.filter(user => {
        return user.user_roles && user.user_roles.some(role => role.id === 1)
      })
      return newList
    }
  },
  mounted: function () {
    if (this.reportId === 'new') {
      this.setEmlpoyees([this.$store.state.authentication.user.user_info.id])
    }
    if (this.reportId === 'new' && !this.project ) {
      this.setProject(1)
    }
  },
  methods: {
    submitReport () {
      if (this.validate()) {
        let router = this.reportType === 'outreach' ? 'ReportOutreachList' : 'ReportCaseList'
        this.$router.push({name: router})
      }
    },
    setDate (e) {
      this.$store.commit("newOutreachReports/setDate", e)
    },
    setLocation (e) {
      this.$store.commit("newOutreachReports/setLocation", e)
    },
    setEmlpoyees (e) {
      this.$store.commit("newOutreachReports/setEmlpoyees", e)
    },
    setProject (e) {
      this.$store.commit("newOutreachReports/setProject", e)
    },

    validate () {
      return this.$refs.form.validate()
    }
  }
}
</script>

<style lang="scss" scoped>
.loading-dialog {
  background-color: #303030
}

.outreach-header {
  background-color: #1976d2 !important;
  opacity: 0.8;
  padding: 10px
}

.case-header {
  background-color: #ffc107 !important;
  opacity: 0.8;
  padding: 10px
}

.read-only-header {
  background-color: gray !important;
  opacity: 0.8;
  padding: 10px
}

.content {
  max-width: 800px;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/new/ReportOutreachNew.vue